import type { LiveEvent } from '@rp/contracts'
import type { LiveEventSourceFactory } from '../../api/events'
import { LIVE_COPY } from './copy'
import { useLiveEvents } from './useLiveEvents'

export interface LiveEventsProps {
  onInbox: (event: LiveEvent) => void
  factory?: LiveEventSourceFactory
}

export const LiveEvents = ({ onInbox, factory }: LiveEventsProps) => {
  const { connected } = useLiveEvents({ onInbox, ...(factory === undefined ? {} : { factory }) })
  if (connected) return null
  return (
    <p className="live-connection" role="status">
      {LIVE_COPY.disconnected}
    </p>
  )
}
